<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName"> 

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ User.name + ' ' + User.lastname }}</p>
      <small>{{User.roleName}}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img  key="onlineImg" :src="avatar" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/dashboard/profile/user')">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t(`PROFILE.profile`)}}</span>
          </li>
          
          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t(`PROFILE.logout`)}}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth';
import IndexedDB from '@/helpers/IndexedDB.js';
import { logout, clearStore } from '@/serviforms/login/logout.js'

export default {
  data () {
    return {

    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    User() {
      return  this.$store.state.user
    },
    avatar() {
      return this.User.picture || '/img/avatar-s-27.924e511a.jpg';
    }
  },
  methods: {
    logout () {    

      // if user is logged in via auth0
      if (this.$auth.profile) this.$auth.logOut()

      // if user is logged in via firebase
      const firebaseCurrentUser = firebase.auth().currentUser

      if (firebaseCurrentUser) {
        firebase.auth().signOut().then(async () => {
          await logout();
          this.ClearStorages(); 
          clearStore()         
          // this.$router.push('/pages/login').catch(() => {})
        })
      }

      this.ClearStorages();
     
    },
    async ClearStorages() {
      await IndexedDB.truncate('users');
      // If JWT login
      if (localStorage.getItem('accessToken')) {
        localStorage.removeItem('accessToken')        
      }

      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change('all')
      // localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/pages/login').catch(() => {})

    }
  }
}
</script>
